import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { IReject, IResolve } from '@df/api/request/request.service';
import { SearchResult } from '@df/search/search-result';
import { SearchService } from '@df/search/search.service';
import { NSearch } from './df-search.config';

export const SEARCH_PATH = '/search';

@Injectable({
    providedIn: 'root'
})
export class SearchResolver implements Resolve<SearchResult> {
    protected router = inject(Router);
    protected searchService = inject(SearchService);
    protected config = inject(NSearch.OPTIONS);

    /**
     * Resolve method
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<SearchResult> {
        return new Promise((resolve: IResolve, reject: IReject) => {
            const term = this.getTerm(route);

            this.getSearch(term)
                .then(result => {
                    const redirect = result.data?.redirect;

                    if (redirect) {
                        if (redirect.match(/https?:\/\//)) {
                            window.location.href = redirect;
                        } else {
                            this.router.navigateByUrl(redirect);
                        }
                    } else {
                        resolve(result);
                    }
                })
                .catch(reject);
        });
    }

    getTerm(route: ActivatedRouteSnapshot): string {
        const url = route.url.map(u => u.path).join('/');

        return decodeURIComponent(url);
    }

    getSearch(term: string): Promise<SearchResult> {
        return this.searchService.search({ q: term, ...this.config.options.view });
    }
}
